var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"timeline"},_vm._l((_vm.items),function(item){return _c('line-item',{key:item.id,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }